import React from 'react'
import { Button } from 'react-native-paper'
import { Text, View } from 'react-native'
import { theme } from '@linqpal/common-frontend'
import { IconCloseCross, WarningIcon } from '../../assets/icons'
import {
  composeStyle,
  webSpecificStyle,
} from '@linqpal/common-frontend/src/helpers'
import { GetIcon } from '../atoms/GetIcon'
import { Link } from '../atoms/Link'
import SModal from './SModal'

const { commonColors } = theme

interface ConfirmPromptProps {
  visible: boolean
  onDismiss: () => void
  title?: string
  message: string | React.ReactNode
  firstButton?: any
  secondButton?: any
  link?: any
  icon?: React.ReactNode
  customButton?: any
  exitable?: boolean
}

interface OptionButtonProps {
  title: string
  bgColor: string
  mode: 'text' | 'outlined' | 'contained'
  onPress: () => void
  labelStyle?: any
  contentStyle?: any
  compact?: boolean
}

const OptionButton = ({
  title,
  bgColor,
  mode,
  onPress,
  labelStyle,
  contentStyle,
  ...props
}: OptionButtonProps) => {
  return (
    <Button
      mode={mode}
      uppercase={false}
      style={{ backgroundColor: bgColor, width: '40%' }}
      onPress={onPress}
      contentStyle={composeStyle(
        !props.compact && { height: 48 },
        contentStyle,
      )}
      theme={{ roundness: 8 }}
      labelStyle={composeStyle(
        { fontSize: 16, fontWeight: '500', color: 'white' },
        webSpecificStyle({ userSelect: 'none' }),
        labelStyle,
      )}
    >
      {title}
    </Button>
  )
}

export const ConfirmPrompt = ({
  visible,
  onDismiss,
  title = '',
  message,
  firstButton,
  secondButton,
  link = null,
  icon,
  customButton,
  exitable = true,
}: ConfirmPromptProps) => {
  return (
    <>
      {visible && (
        <SModal
          visible={visible}
          onClose={onDismiss}
          containerStyle={{
            backgroundColor: 'white',
            minWidth: 300,
            borderRadius: 20,
            marginHorizontal: 20,
            padding: 0,
            display: 'flex',
            justifyContent: 'flex-start',
          }}
        >
          <View
            style={{
              backgroundColor: 'white',
              width: 340,
              borderRadius: 20,
              paddingBottom: 20,
            }}
          >
            <View
              style={{ height: exitable ? 40 : 24, alignItems: 'flex-end' }}
            >
              {exitable && (
                <GetIcon
                  icon={<IconCloseCross height="14" width="14" />}
                  onPress={onDismiss}
                />
              )}
            </View>
            <View style={{ alignItems: 'center', marginBottom: 20 }}>
              {icon || <WarningIcon />}
              <Text
                style={{
                  fontSize: 20,
                  fontWeight: '600',
                  textAlign: 'center',
                  width: '70%',
                  marginTop: 22,
                }}
              >
                {title}
              </Text>
              <Text
                style={{
                  fontSize: 16,
                  fontWeight: '400',
                  textAlign: 'center',
                  width: '80%',
                  marginTop: 18,
                  lineHeight: 26,
                  color: commonColors.textLight,
                }}
              >
                {message}
              </Text>
            </View>
            <View
              style={{ flexDirection: 'row', justifyContent: 'space-around' }}
            >
              <OptionButton
                title={firstButton.title}
                mode={firstButton.mode}
                bgColor={firstButton.bgColor}
                labelStyle={{
                  color: firstButton.textColor,
                  marginHorizontal: 0,
                }}
                onPress={firstButton.onPress}
              />
              {customButton}
              {secondButton && (
                <OptionButton
                  title={secondButton.title}
                  mode={secondButton.mode}
                  bgColor={secondButton.bgColor}
                  onPress={secondButton.onPress}
                />
              )}
            </View>
            {link && (
              <Link
                title={link.title}
                textStyle={link.textStyle}
                onPress={link.onPress}
              />
            )}
          </View>
        </SModal>
      )}
    </>
  )
}
